module.exports = __webpack_public_path__ + "static/busan-ccf5fe2ac3b7bac72cbbc80c4a8412cc.jpg";